import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useAttribute from "./useAttribute";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function ({attributeId, categoryId, setEditFormIsOpen, callback=null}) {

  const { reset, handleSubmit, setErrors, attributeFields } = useAttribute();

  useEffect(() => {
    axios.get('attributes/' + attributeId, {params: {category_id : categoryId}}).then(res => {
      reset(res.data.attribute);
    });
  }, []);

  const editAttribute = data => {
    data.category_id = categoryId;

    axios.put('attributes/' + attributeId, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Attributes has been updated successfully!', {
            icon: "success",
          });
          setEditFormIsOpen(false)
          if (callback) callback(attributeId);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <card>
      <form className="form w-100 row" onSubmit={handleSubmit(editAttribute)}>
        {attributeFields}
        <SubmitButton
          title="Update"
          classes="float-right inline-block w-auto mx-3"
        />
      </form>
    </card>
  );
}